import React, { FC } from 'react';
const EmbedIcon: FC = () => {
    return (
        <svg
            className={`svg-inline`}
            viewBox="0 0 13 12"
            fill="none"
            stroke="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.375 3.36719L0.875 5.86719L3.375 8.36719"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.625 3.36719L12.125 5.86719L9.625 8.36719"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M7.75 0.867188L5.25 10.8672" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default EmbedIcon;
